import * as ModelClasses from '../model'
import { ValidBusinessObject } from '@iotv/iotv-v3-types'

export type ValidModelType = keyof typeof ModelClasses | 'AggregationGroup' | 'KMLFileLink'

export type ValidModelObject<T extends ValidModelType> = ValidBusinessObject & { type: T }
export type ValidModelGroup<T extends ValidModelType> = ValidModelObject<'Group'> & { supportedType: T }

export type ValidModelObjects<T extends ValidModelType> = ValidModelObject<T>[]

const ModelClassList = Object.keys(ModelClasses)

export { ModelClassList }

export const isValidModelTypeId = (objectTypeId: string): objectTypeId is ValidModelType => ModelClassList.includes(objectTypeId)
